export default __webpack_public_path__ + "static/media/risk_very_low.e980f0c4.svg";